(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5235],{

/***/ 94913:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured/[slug]",
      function () {
        return __webpack_require__(36120);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);








var Breadcrumb = function(_param) {
    var _theme = _param.theme, theme = _theme === void 0 ? "light-bg" : _theme, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "theme"
    ]);
    var textColor = theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.text */ .O9.text : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ol", {
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0;padding:0;display:flex;align-items:center;color:", textColor, ";font-size:11px;line-height:1.45;li:not(:last-child)::after{content:'/';margin:0 5px;color:", theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray70 */ .O9.gray70 : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";font-size:11px;line-height:1.45;}a{transition:text-decoration 0.2s ease;text-decoration:underline solid transparent;:hover{text-decoration:underline solid ", textColor, ";}}a:visited,a:link{color:", textColor, ";}"),
        className: props.className,
        children: props.children.map(function(component, i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("li", {
                    itemProp: "itemListElement",
                    itemScope: true,
                    itemType: "https://schema.org/ListItem",
                    children: [
                        component,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                            itemProp: "position",
                            content: i + 1 + ""
                        })
                    ]
                })
            }, i);
        })
    });
};
var BreadcrumbLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
            itemProp: "item",
            className: props.className,
            target: props.external ? "_blank" : "_top",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                itemProp: "name",
                children: props.children
            })
        })
    }));
};
var BreadcrumbItem = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
        itemProp: "name",
        className: props.className,
        children: props.children
    });
};


/***/ }),

/***/ 14380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FormattedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15598);




// Returns formatted date of iso string
var FormattedDate = function(props) {
    if (!props.children) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
            className: _lib_wovn__WEBPACK_IMPORTED_MODULE_2__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
            suppressHydrationWarning: true,
            children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(props.children, "yyyy/MM/dd")
        })
    });
};


/***/ }),

/***/ 15071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ TagButton; },
/* harmony export */   "U": function() { return /* binding */ TagButtonGroup; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);






var TagButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:inline-block;margin:0 4px 4px 0;"),
        "data-test-id": "tag",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: _lib_url__WEBPACK_IMPORTED_MODULE_3__/* .TAG_HREF */ .cS,
            as: "slug" in props.tag ? (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .newTagPath */ .w6)(props.tag) : props.tag.path,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                "data-test-id": "tag-link",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";border-radius:3px;padding:2px 6px;font-size:12px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray90 */ .O9.gray90, ";text-align:center;display:block;white-space:nowrap;transition:0.3s;&:hover{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray70 */ .O9.gray70, ";}"),
                className: "tag-button ".concat(props.className ? props.className : ""),
                children: "#".concat(props.tag.name)
            })
        })
    });
};
var TagButtonGroup = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0 0 -4px;padding:0;"),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: props.children
    });
};


/***/ }),

/***/ 367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PublishedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14380);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57923);






var PublishedDate = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("time", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";font-size:14px;letter-spacing:0.02em;line-height:1.5;"),
        className: props.className,
        dateTime: (0,_lib_date__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(props.children, "yyyy-MM-dd"),
        suppressHydrationWarning: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_atoms_FormattedDate__WEBPACK_IMPORTED_MODULE_2__/* .FormattedDate */ .J, {
            children: props.children
        })
    });
};


/***/ }),

/***/ 63911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ContentfulResponsiveImage; }
/* harmony export */ });
/* unused harmony exports fromContentful, params, toSize, createOptimizedUrl, ContentfulResizedImage */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var fromContentful = function(src) {
    return src.includes("//images.ctfassets.net/");
};
var params = function(w) {
    return "w=".concat(w);
};
var toSize = function(res) {
    switch(res){
        case "hi":
            return 840;
        case "slightly-low":
            return 480;
        case "low":
            return 320;
        case "extra-low":
            return 160;
    }
    return 720 // normal
    ;
};
var createOptimizedUrl = function() {
    return function(src, res) {
        return "".concat(src, "?").concat(params(toSize(res)));
    };
};
var ContentfulResizedImage = function(props) {
    if (!fromContentful(props.src)) {
        return /*#__PURE__*/ _jsx("img", _object_spread({}, props));
    }
    return /*#__PURE__*/ _jsx("img", _object_spread_props(_object_spread({}, props), {
        src: "".concat(props.src, "?").concat(params(toSize(props.res)))
    }));
};
// NOTE: Breakpoint 420px for Xperia 1 (viewport width 418px, 2px for safe margin)
var ContentfulResponsiveImage = function(props) {
    if (!fromContentful(props.src)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
                srcSet: "".concat(props.src, "?").concat(params(toSize(props.res))),
                media: "(max-width: 420px)"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
                srcSet: "".concat(props.src, "?").concat(params(1280))
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                src: "".concat(props.src, "?").concat(params(1280))
            }))
        ]
    });
};


/***/ }),

/***/ 92339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ LockIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var _atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96747);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18584);
/* harmony import */ var _lib_article__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9427);
/* harmony import */ var _tokens_mediaquery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67014);







var small = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("@media (min-width:", _tokens_mediaquery__WEBPACK_IMPORTED_MODULE_5__/* .desktopMinWidth */ .n, "){font-size:24px;}");
var common = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin-right:3px;");
var LockIcon = function(props) {
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .a)();
    switch((0,_lib_article__WEBPACK_IMPORTED_MODULE_3__/* .lockTypeOf */ .K3)(user, props.article)){
        case "none":
            return null;
        case "locked":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__/* .IcomoonIcon */ .g, {
                name: "lock-fill",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(common, "            color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";", props.size === "small" && small)
            });
        case "unlocked":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_0__/* .IcomoonIcon */ .g, {
                name: "unlock-fill",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(common, "            color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray60 */ .O9.gray60, ";", props.size === "small" && small)
            });
    }
};


/***/ }),

/***/ 67014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ desktopMaxWidth; },
/* harmony export */   "n": function() { return /* binding */ desktopMinWidth; }
/* harmony export */ });
var desktopMaxWidth = "769px";
var desktopMinWidth = "770px";


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NX": function() { return /* binding */ fetchFeaturedByArticle; },
/* harmony export */   "ou": function() { return /* binding */ fetchFeaturedList; },
/* harmony export */   "rK": function() { return /* binding */ fetchFeatured; },
/* harmony export */   "rv": function() { return /* binding */ trimTextForNewsPicks; }
/* harmony export */ });
/* unused harmony export convertFeatured */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var _api_contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58585);
/* harmony import */ var _article__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9427);
/* harmony import */ var _url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48261);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79240);








var fetchFeatured = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(featuredSlug) {
        var featured, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    featured = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getFeatured */ .$)(featuredSlug)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        featured = convertFeatured(data);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_5__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        featured
                    ];
            }
        });
    });
    return function fetchFeatured(featuredSlug) {
        return _ref.apply(this, arguments);
    };
}();
var fetchFeaturedList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var featuredList, items, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    featuredList = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getFeaturedList */ .R9)()
                    ];
                case 2:
                    items = _state.sent();
                    featuredList = items.map(function(item) {
                        return convertFeatured(item);
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_5__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        featuredList
                    ];
            }
        });
    });
    return function fetchFeaturedList() {
        return _ref.apply(this, arguments);
    };
}();
var fetchFeaturedByArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(articleId) {
        var featured, data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    featured = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .getFeaturedByArticle */ .Hp)(articleId)
                    ];
                case 2:
                    data = _state.sent();
                    if (data) {
                        featured = convertFeatured(data);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_5__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        featured
                    ];
            }
        });
    });
    return function fetchFeaturedByArticle(articleId) {
        return _ref.apply(this, arguments);
    };
}();
var convertFeatured = function(featured) {
    var headerImage = {
        url: (0,_url__WEBPACK_IMPORTED_MODULE_2__/* .withProtocol */ .Ac)(featured.headerImage.fields.file.url),
        title: featured.headerImage.fields.title
    };
    var ogpImage = {
        url: (0,_url__WEBPACK_IMPORTED_MODULE_2__/* .withProtocol */ .Ac)(featured.ogpImage.fields.file.url),
        title: featured.ogpImage.fields.title
    };
    var articles = (0,_api_contentful__WEBPACK_IMPORTED_MODULE_0__/* .filterPublished */ .re)(featured.articles).map(function(res) {
        return (0,_article__WEBPACK_IMPORTED_MODULE_1__/* .convertArticle */ .AP)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, res.fields), {
            id: res.sys.id
        }));
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, featured), {
        articles: articles,
        headerImage: headerImage,
        ogpImage: ogpImage
    });
};
var trimTextForNewsPicks = function(text) {
    return text.replace("スタートアップ最前線", "");
};


/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ IGNORED_BY_WOVN_CLASS_NAME; }
/* harmony export */ });
var IGNORED_BY_WOVN_CLASS_NAME = "wovn-ignore";


/***/ }),

/***/ 61753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33431);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56902);
/* harmony import */ var _lib_gtm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11543);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18584);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96747);













var Error = function(param) {
    var _statusCode = param.statusCode, statusCode = _statusCode === void 0 ? 404 : _statusCode, err = param.err;
    var msg = msgOf(statusCode);
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var errorMessage = "".concat(err === null || err === void 0 ? void 0 : err.name, " ").concat(err === null || err === void 0 ? void 0 : err.message);
        console.log("error", errorMessage);
        (0,_lib_gtm__WEBPACK_IMPORTED_MODULE_5__/* .pushEventToGTM */ .K)(user, _lib_tracking__WEBPACK_IMPORTED_MODULE_4__/* .ERROR */ .pn, errorMessage);
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_common_Template__WEBPACK_IMPORTED_MODULE_1__/* .Template */ .Y, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("text-align:center;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30, ";padding:0 15px;"),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    id: "error-page-error-code",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:100px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.statusCodeForDisplay
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:28px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.title
                }),
                msg.image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("img", {
                    src: msg.image,
                    alt: "Error Image",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-top:64px;}width:240px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{width:320px;}")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:16px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{font-size:18px;}"),
                    "data-test-id": "error-page-description",
                    children: msg.description
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("a", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;margin-bottom:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-bottom:64px;}display:flex;align-items:center;justify-content:center;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__/* .IcomoonIcon */ .g, {
                                name: "arrow-back",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;padding-right:4px;")
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;"),
                                children: "トップに戻る"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var msgOf = function(statusCode) {
    switch(statusCode){
        case 403:
            return {
                title: "FORBIDDEN",
                description: "このページへのアクセスは禁止されています。"
            };
        case 404:
            return {
                image: "/static/images/error/illust-404.png",
                description: "お探しのページは見つかりませんでした。"
            };
        case 500:
        default:
            return {
                statusCodeForDisplay: 500,
                title: "INTERNAL SERVER ERROR"
            };
    }
};
var handleTrailingSlash = function(req, res) {
    if (req.url) {
        var urlParts = req.url.split("?");
        if (urlParts[0].endsWith("/")) {
            urlParts[0] = urlParts[0].substring(0, urlParts[0].length - 1);
            res.writeHead(301, {
                Location: urlParts.join("?")
            });
            res.end();
        }
    }
};
Error.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(ctx) {
        var req, res, err, statusCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            req = ctx.req, res = ctx.res, err = ctx.err;
            statusCode = res ? res.statusCode : err ? err.statusCode : 404;
            if (statusCode === 404 && req && res) {
                handleTrailingSlash(req, res);
            }
            if (res) {
                // Running on the server
                if (statusCode === 404) {
                    return [
                        2,
                        {
                            statusCode: 404
                        }
                    ];
                }
            }
            return [
                2,
                {
                    statusCode: statusCode,
                    err: err
                }
            ];
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (Error);


/***/ }),

/***/ 36120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/Template.tsx
var Template = __webpack_require__(33431);
// EXTERNAL MODULE: ./lib/featured.ts
var lib_featured = __webpack_require__(16368);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/markdown-to-jsx/dist/index.modern.js
var index_modern = __webpack_require__(35576);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/api/contentful.ts
var contentful = __webpack_require__(58585);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
// EXTERNAL MODULE: ./components/pages/articles/LockIcon.tsx
var LockIcon = __webpack_require__(92339);
// EXTERNAL MODULE: ./components/atoms/TagButton.tsx
var TagButton = __webpack_require__(15071);
// EXTERNAL MODULE: ./components/common/PublishedDate.tsx
var PublishedDate = __webpack_require__(367);
;// CONCATENATED MODULE: ./components/pages/featured/FeaturedCard.tsx














var FeaturedCard = function(props) {
    var linkProps = {
        as: (0,url/* articlePath */.wL)(props.article),
        href: url/* ARTICLE_HREF */.ph
    };
    return (0,contentful/* notPublishedYet */.pN)(props.article.publishedAt) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:16px 24px;transition:0.3s;height:100%;margin-top:8px;", dist.mq.large, "{flex-direction:column;margin:0;padding:0;}"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Image */.Zb.Image, {
                src: "/static/images/coming-soon-ogp.jpg",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:100%;figure{line-height:0.93;width:112px !important;", dist.mq.large, "{width:100% !important;}}")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Content */.Zb.Content, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&&{display:flex;flex-direction:column;padding:0 0 0 8px;", dist.mq.large, "{padding:8px 0 0;}}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        article: props.article,
                        index: props.index,
                        clickable: false,
                        comingSoon: true
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card */.Zb, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;padding:20px;transition:0.3s;height:100%;border-top:8px solid ", dist/* colors.gray40 */.O9.gray40, ";", dist.mq.large, "{padding:0;border-top:0;}"),
        className: props.className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("height:100%;"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;::after{content:'';position:absolute;left:0;top:0;display:block;width:100%;height:100%;background-color:#000;opacity:0;transition:opacity 0.2s ease;}:hover{::after{opacity:0.08;}}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Card.Image */.Zb.Image, {
                            src: props.article.headerImage.url,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("figure{line-height:0.93;}")
                        })
                    })
                })
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Card.Content */.Zb.Content, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&&{display:flex;flex-direction:column;padding:16px 0 0;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PublishedDate/* PublishedDate */.n, {
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";"),
                                    children: props.article.publishedAt
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                            article: props.article,
                                            index: props.index,
                                            clickable: true
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:13px;line-height:1.5;letter-spacing:0.02em;color:", dist/* colors.black30 */.O9.black30, ";max-height:calc(14px * 1.5 * 4);-webkit-line-clamp:4;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;margin-bottom:8px;", dist.mq.large, "{font-size:14px;}"),
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_modern/* default */.ZP, {
                                                options: {
                                                    overrides: {
                                                        blockquote: function(props) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread/* default */.Z)({}, props));
                                                        },
                                                        p: function(props) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread/* default */.Z)({}, props));
                                                        },
                                                        a: function(props) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                                                children: props.children
                                                            }));
                                                        },
                                                        img: function() {
                                                            return null;
                                                        },
                                                        iframe: function() {
                                                            return null;
                                                        }
                                                    }
                                                },
                                                children: (0,lib_featured/* trimTextForNewsPicks */.rv)(props.article.introduction)
                                            })
                                        })
                                    ]
                                })
                            }))
                        ]
                    }),
                    props.article.newTags && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButtonGroup */.U, {
                        children: props.article.newTags.map(function(tag, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton/* TagButton */.D, {
                                tag: tag
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
var Title = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;margin:8px 0;", props.comingSoon && "\n            ".concat(dist.mq.small, "{\n              margin: 0;\n            }\n          "), "      \\`}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textStrong */.O9.textStrong, ";font-size:16px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";line-height:1.5;letter-spacing:0.02em;transition:border-color 0.2s linear;border-bottom:1px solid transparent;&:hover{border-bottom:", props.clickable ? "1px solid ".concat(dist/* colors.textStrong */.O9.textStrong) : "1px solid transparent", ";}", dist.mq.large, "{font-size:20px;}", props.comingSoon && "\n            ".concat(dist.mq.small, "{\n              font-size: 15px;\n            }\n          ")),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LockIcon/* LockIcon */.m, {
                    article: props.article
                }),
                props.article.title
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/pages/articles/ContentfulResponsiveImage.tsx
var ContentfulResponsiveImage = __webpack_require__(63911);
// EXTERNAL MODULE: ./components/atoms/Breadcrumb.tsx
var Breadcrumb = __webpack_require__(56894);
;// CONCATENATED MODULE: ./components/pages/featured/FeaturedHeader.tsx







var FeaturedHeader = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;position:relative;background-color:", dist/* colors.blueGray50 */.O9.blueGray50, ";line-height:0;"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentfulResponsiveImage/* ContentfulResponsiveImage */.s, {
                        src: props.featured.headerImage.url,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;width:100%;height:100%;max-height:560px;display:none;", dist.mq.large, "{display:inline;}")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentfulResponsiveImage/* ContentfulResponsiveImage */.s, {
                        src: props.featured.ogpImage.url,
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;width:100%;height:100%;", dist.mq.large, "{display:none;}")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(dist.mq.large, "{position:absolute;margin:0 auto;padding:0;top:20px;left:max(0px,50% - 1120px / 2);}"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Breadcrumb/* Breadcrumb */.aG, {
                            theme: "dark-bg",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;", dist.mq.large, "{display:flex;}"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbLink */.At, {
                                    href: "/",
                                    children: "ホーム"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbLink */.At, {
                                    href: url/* featuredIndexPath */.Px,
                                    children: "特集"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbItem */.gN, {
                                    children: props.featured.title
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;", dist.mq.large, "{display:block;color:", dist/* colors.white00 */.O9.white00, ";position:absolute;margin:0;padding:0;top:50%;left:max(0px,50% - 1120px / 2);-ms-transform:translateY(-50%);-webkit-transform:translateY(-50%);transform:translateY(-50%);width:680px;}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;font-size:14px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";letter-spacing:0.1em;line-height:1.5;"),
                                children: "SPECIAL FEATURE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.white00 */.O9.white00, ";letter-spacing:1.5px;line-height:normal;font-size:42px;font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";text-align:", props.featured.headerLayout, ";letter-spacing:0.01em;line-height:1.5;margin:16px 0 0;"),
                                children: props.featured.title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:16px 0 0;font-size:16px;line-height:2;letter-spacing:0.02em;"),
                                children: props.featured.description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.black20 */.O9.black20, ";color:", dist/* colors.white00 */.O9.white00, ";padding:16px 24px;", dist.mq.large, "{display:none;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;font-size:14px;line-height:1.75;letter-spacing:0.02em;"),
                    children: props.featured.description
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./pages/_error.tsx
var _error = __webpack_require__(61753);
// EXTERNAL MODULE: ./components/common/Head.tsx
var Head = __webpack_require__(12912);
;// CONCATENATED MODULE: ./pages/featured/[slug].tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                width: 100%;\n                ",
        " {\n                  margin-top: 64px;\n                  max-width: 512px;\n                  &:nth-of-type(odd) {\n                    transform: translateY(-80px);\n                  }\n                  &:nth-of-type(odd):last-child {\n                    margin-bottom: -16px;\n                  }\n                  &:nth-of-type(even):last-child {\n                    margin-bottom: 64px;\n                  }\n                }\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var FeaturedPage = function(props) {
    if (!props.featured) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_error["default"], {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Template/* Template */.Y, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* FeaturedHead */.vB, {
                featured: props.featured
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:", dist/* colors.gray40 */.O9.gray40, ";", dist.mq.large, "{background-color:", dist/* colors.white00 */.O9.white00, ";}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedHeader, {
                        featured: props.featured
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:space-between;flex-wrap:wrap;max-width:", dist/* breakpoint.extraLarge */.eq.extraLarge, "px;padding:0 0 48px;margin:0px auto;", dist.mq.large, "{margin-top:-40px;padding:0;}"),
                        children: props.featured.articles.map(function(article, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedCard, {
                                article: article,
                                index: i + 1,
                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), dist.mq.large)
                            }, article.id);
                        })
                    })
                ]
            })
        ]
    });
};
FeaturedPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, slug, featured;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query;
                    slug = query.slug;
                    return [
                        4,
                        (0,lib_featured/* fetchFeatured */.rK)(slug)
                    ];
                case 1:
                    featured = _state.sent();
                    return [
                        2,
                        {
                            featured: featured
                        }
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _slug_ = (FeaturedPage);


/***/ }),

/***/ 35576:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports RuleType, compiler, sanitizer, slugify */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function t(){return t=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},t.apply(this,arguments)}const n=["children","options"],r={blockQuote:"0",breakLine:"1",breakThematic:"2",codeBlock:"3",codeFenced:"4",codeInline:"5",footnote:"6",footnoteReference:"7",gfmTask:"8",heading:"9",headingSetext:"10",htmlBlock:"11",htmlComment:"12",htmlSelfClosing:"13",image:"14",link:"15",linkAngleBraceStyleDetector:"16",linkBareUrlDetector:"17",linkMailtoDetector:"18",newlineCoalescer:"19",orderedList:"20",paragraph:"21",ref:"22",refImage:"23",refLink:"24",table:"25",tableSeparator:"26",text:"27",textBolded:"28",textEmphasized:"29",textEscaped:"30",textMarked:"31",textStrikethroughed:"32",unorderedList:"33"};var i;!function(e){e[e.MAX=0]="MAX",e[e.HIGH=1]="HIGH",e[e.MED=2]="MED",e[e.LOW=3]="LOW",e[e.MIN=4]="MIN"}(i||(i={}));const l=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((e,t)=>(e[t.toLowerCase()]=t,e),{class:"className",for:"htmlFor"}),a={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},o=["style","script"],c=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,s=/mailto:/i,d=/\n{2,}$/,u=/^(\s*>[\s\S]*?)(?=\n\n|$)/,p=/^ *> ?/gm,f=/^(?:\[!([^\]]*)\]\n)?([\s\S]*)/,h=/^ {2,}\n/,m=/^(?:( *[-*_])){3,} *(?:\n *)+\n/,g=/^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/,y=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,k=/^(`+)((?:\\`|[^`])+)\1/,x=/^(?:\n *)*\n/,b=/\r\n?/g,v=/^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/,C=/^\[\^([^\]]+)]/,$=/\f/g,S=/^---[ \t]*\n(.|\n)*\n---[ \t]*\n/,w=/^\s*?\[(x|\s)\]/,E=/^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,z=/^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,L=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,A=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i,T=/&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,B=/^<!--[\s\S]*?(?:-->)/,O=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,M=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,R=/^\{.*\}$/,I=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,U=/^<([^ >]+@[^ >]+)>/,D=/^<([^ >]+:\/[^ >]+)>/,N=/-([a-z])?/gi,j=/^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/,H=/^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/,P=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,_=/^\[([^\]]*)\] ?\[([^\]]*)\]/,F=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,G=/\t/g,W=/(^ *\||\| *$)/g,Z=/^ *:-+: *$/,q=/^ *:-+ *$/,Q=/^ *-+: *$/,V="((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)",X=new RegExp(`^([*_])\\1${V}\\1\\1(?!\\1)`),J=new RegExp(`^([*_])${V}\\1(?!\\1)`),K=new RegExp(`^(==)${V}\\1`),Y=new RegExp(`^(~~)${V}\\1`),ee=/^\\([^0-9A-Za-z\s])/,te=/\\([^0-9A-Za-z\s])/g,ne=/^([\s\S](?:(?!  |[0-9]\.)[^*_~\-\n<`\\\[!])*)/,re=/^\n+/,ie=/^([ \t]*)/,le=/\\([^\\])/g,ae=/(?:^|\n)( *)$/,oe="(?:\\d+\\.)",ce="(?:[*+-])";function se(e){return"( *)("+(1===e?oe:ce)+") +"}const de=se(1),ue=se(2);function pe(e){return new RegExp("^"+(1===e?de:ue))}const fe=pe(1),he=pe(2);function me(e){return new RegExp("^"+(1===e?de:ue)+"[^\\n]*(?:\\n(?!\\1"+(1===e?oe:ce)+" )[^\\n]*)*(\\n|$)","gm")}const ge=me(1),ye=me(2);function ke(e){const t=1===e?oe:ce;return new RegExp("^( *)("+t+") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1"+t+" (?!"+t+" ))\\n*|\\s*\\n*$)")}const xe=ke(1),be=ke(2);function ve(e,t){const n=1===t,i=n?xe:be,l=n?ge:ye,a=n?fe:he;return{match:Oe(function(e,t){const n=ae.exec(t.prevCapture);return n&&(t.list||!t.inline&&!t.simple)?i.exec(e=n[1]+e):null}),order:1,parse(e,t,r){const i=n?+e[2]:void 0,o=e[0].replace(d,"\n").match(l);let c=!1;return{items:o.map(function(e,n){const i=a.exec(e)[0].length,l=new RegExp("^ {1,"+i+"}","gm"),s=e.replace(l,"").replace(a,""),d=n===o.length-1,u=-1!==s.indexOf("\n\n")||d&&c;c=u;const p=r.inline,f=r.list;let h;r.list=!0,u?(r.inline=!1,h=Ee(s)+"\n\n"):(r.inline=!0,h=Ee(s));const m=t(h,r);return r.inline=p,r.list=f,m}),ordered:n,start:i}},render:(t,n,i)=>e(t.ordered?"ol":"ul",{key:i.key,start:t.type===r.orderedList?t.start:void 0},t.items.map(function(t,r){return e("li",{key:r},n(t,i))}))}}const Ce=new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),$e=/^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/,Se=[u,g,y,E,L,z,j,xe,be],we=[...Se,/^[^\n]+(?:  \n|\n{2,})/,A,B,M];function Ee(e){let t=e.length;for(;t>0&&e[t-1]<=" ";)t--;return e.slice(0,t)}function ze(e){return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function Le(e){return Q.test(e)?"right":Z.test(e)?"center":q.test(e)?"left":null}function Ae(e,t,n,r){const i=n.inTable;n.inTable=!0;let l=[[]],a="";function o(){if(!a)return;const e=l[l.length-1];e.push.apply(e,t(a,n)),a=""}return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e,t,n)=>{"|"===e.trim()&&(o(),r)?0!==t&&t!==n.length-1&&l.push([]):a+=e}),o(),n.inTable=i,l}function Te(e,t,n){n.inline=!0;const i=e[2]?e[2].replace(W,"").split("|").map(Le):[],l=e[3]?function(e,t,n){return e.trim().split("\n").map(function(e){return Ae(e,t,n,!0)})}(e[3],t,n):[],a=Ae(e[1],t,n,!!l.length);return n.inline=!1,l.length?{align:i,cells:l,header:a,type:r.table}:{children:a,type:r.paragraph}}function Be(e,t){return null==e.align[t]?{}:{textAlign:e.align[t]}}function Oe(e){return e.inline=1,e}function Me(e){return Oe(function(t,n){return n.inline?e.exec(t):null})}function Re(e){return Oe(function(t,n){return n.inline||n.simple?e.exec(t):null})}function Ie(e){return function(t,n){return n.inline||n.simple?null:e.exec(t)}}function Ue(e){return Oe(function(t){return e.exec(t)})}function De(e,t){if(t.inline||t.simple)return null;let n="";e.split("\n").every(e=>(e+="\n",!Se.some(t=>t.test(e))&&(n+=e,!!e.trim())));const r=Ee(n);return""==r?null:[n,,r]}function Ne(e){try{if(decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g,"").match(/^\s*(javascript|vbscript|data(?!:image)):/i))return null}catch(e){return null}return e}function je(e){return e.replace(le,"$1")}function He(e,t,n){const r=n.inline||!1,i=n.simple||!1;n.inline=!0,n.simple=!0;const l=e(t,n);return n.inline=r,n.simple=i,l}function Pe(e,t,n){const r=n.inline||!1,i=n.simple||!1;n.inline=!1,n.simple=!0;const l=e(t,n);return n.inline=r,n.simple=i,l}function _e(e,t,n){const r=n.inline||!1;n.inline=!1;const i=e(t,n);return n.inline=r,i}const Fe=(e,t,n)=>({children:He(t,e[2],n)});function Ge(){return{}}function We(){return null}function Ze(...e){return e.filter(Boolean).join(" ")}function qe(e,t,n){let r=e;const i=t.split(".");for(;i.length&&(r=r[i[0]],void 0!==r);)i.shift();return r||n}function Qe(n="",i={}){function d(e,n,...r){const l=qe(i.overrides,`${e}.props`,{});return i.createElement(function(e,t){const n=qe(t,e);return n?"function"==typeof n||"object"==typeof n&&"render"in n?n:qe(t,`${e}.component`,e):e}(e,i.overrides),t({},n,l,{className:Ze(null==n?void 0:n.className,l.className)||void 0}),...r)}function W(e){e=e.replace(S,"");let t=!1;i.forceInline?t=!0:i.forceBlock||(t=!1===F.test(e));const n=ae(le(t?e:`${Ee(e).replace(re,"")}\n\n`,{inline:t}));for(;"string"==typeof n[n.length-1]&&!n[n.length-1].trim();)n.pop();if(null===i.wrapper)return n;const r=i.wrapper||(t?"span":"div");let l;if(n.length>1||i.forceWrapper)l=n;else{if(1===n.length)return l=n[0],"string"==typeof l?d("span",{key:"outer"},l):l;l=null}return i.createElement(r,{key:"outer"},l)}function Z(e,t){const n=t.match(c);return n?n.reduce(function(t,n){const r=n.indexOf("=");if(-1!==r){const a=function(e){return-1!==e.indexOf("-")&&null===e.match(O)&&(e=e.replace(N,function(e,t){return t.toUpperCase()})),e}(n.slice(0,r)).trim(),o=function(e){const t=e[0];return('"'===t||"'"===t)&&e.length>=2&&e[e.length-1]===t?e.slice(1,-1):e}(n.slice(r+1).trim()),c=l[a]||a;if("ref"===c)return t;const s=t[c]=function(e,t,n,r){return"style"===t?n.split(/;\s?/).reduce(function(e,t){const n=t.slice(0,t.indexOf(":"));return e[n.trim().replace(/(-[a-z])/g,e=>e[1].toUpperCase())]=t.slice(n.length+1).trim(),e},{}):"href"===t||"src"===t?r(n,e,t):(n.match(R)&&(n=n.slice(1,n.length-1)),"true"===n||"false"!==n&&n)}(e,a,o,i.sanitizer);"string"==typeof s&&(A.test(s)||M.test(s))&&(t[c]=W(s.trim()))}else"style"!==n&&(t[l[n]||n]=!0);return t},{}):null}i.overrides=i.overrides||{},i.sanitizer=i.sanitizer||Ne,i.slugify=i.slugify||ze,i.namedCodesToUnicode=i.namedCodesToUnicode?t({},a,i.namedCodesToUnicode):a,i.createElement=i.createElement||react__WEBPACK_IMPORTED_MODULE_0__.createElement;const q=[],Q={},V={[r.blockQuote]:{match:Ie(u),order:1,parse(e,t,n){const[,r,i]=e[0].replace(p,"").match(f);return{alert:r,children:t(i,n)}},render(e,t,n){const l={key:n.key};return e.alert&&(l.className="markdown-alert-"+i.slugify(e.alert.toLowerCase(),ze),e.children.unshift({attrs:{},children:[{type:r.text,text:e.alert}],noInnerParse:!0,type:r.htmlBlock,tag:"header"})),d("blockquote",l,t(e.children,n))}},[r.breakLine]:{match:Ue(h),order:1,parse:Ge,render:(e,t,n)=>d("br",{key:n.key})},[r.breakThematic]:{match:Ie(m),order:1,parse:Ge,render:(e,t,n)=>d("hr",{key:n.key})},[r.codeBlock]:{match:Ie(y),order:0,parse:e=>({lang:void 0,text:Ee(e[0].replace(/^ {4}/gm,"")).replace(te,"$1")}),render:(e,n,r)=>d("pre",{key:r.key},d("code",t({},e.attrs,{className:e.lang?`lang-${e.lang}`:""}),e.text))},[r.codeFenced]:{match:Ie(g),order:0,parse:e=>({attrs:Z("code",e[3]||""),lang:e[2]||void 0,text:e[4].replace(te,"$1"),type:r.codeBlock})},[r.codeInline]:{match:Re(k),order:3,parse:e=>({text:e[2].replace(te,"$1")}),render:(e,t,n)=>d("code",{key:n.key},e.text)},[r.footnote]:{match:Ie(v),order:0,parse:e=>(q.push({footnote:e[2],identifier:e[1]}),{}),render:We},[r.footnoteReference]:{match:Me(C),order:1,parse:e=>({target:`#${i.slugify(e[1],ze)}`,text:e[1]}),render:(e,t,n)=>d("a",{key:n.key,href:i.sanitizer(e.target,"a","href")},d("sup",{key:n.key},e.text))},[r.gfmTask]:{match:Me(w),order:1,parse:e=>({completed:"x"===e[1].toLowerCase()}),render:(e,t,n)=>d("input",{checked:e.completed,key:n.key,readOnly:!0,type:"checkbox"})},[r.heading]:{match:Ie(i.enforceAtxHeadings?z:E),order:1,parse:(e,t,n)=>({children:He(t,e[2],n),id:i.slugify(e[2],ze),level:e[1].length}),render:(e,t,n)=>d(`h${e.level}`,{id:e.id,key:n.key},t(e.children,n))},[r.headingSetext]:{match:Ie(L),order:0,parse:(e,t,n)=>({children:He(t,e[1],n),level:"="===e[2]?1:2,type:r.heading})},[r.htmlBlock]:{match:Ue(A),order:1,parse(e,t,n){const[,r]=e[3].match(ie),i=new RegExp(`^${r}`,"gm"),l=e[3].replace(i,""),a=(c=l,we.some(e=>e.test(c))?_e:He);var c;const s=e[1].toLowerCase(),d=-1!==o.indexOf(s),u=(d?s:e[1]).trim(),p={attrs:Z(u,e[2]),noInnerParse:d,tag:u};return n.inAnchor=n.inAnchor||"a"===s,d?p.text=e[3]:p.children=a(t,l,n),n.inAnchor=!1,p},render:(e,n,r)=>d(e.tag,t({key:r.key},e.attrs),e.text||(e.children?n(e.children,r):""))},[r.htmlSelfClosing]:{match:Ue(M),order:1,parse(e){const t=e[1].trim();return{attrs:Z(t,e[2]||""),tag:t}},render:(e,n,r)=>d(e.tag,t({},e.attrs,{key:r.key}))},[r.htmlComment]:{match:Ue(B),order:1,parse:()=>({}),render:We},[r.image]:{match:Re($e),order:1,parse:e=>({alt:e[1],target:je(e[2]),title:e[3]}),render:(e,t,n)=>d("img",{key:n.key,alt:e.alt||void 0,title:e.title||void 0,src:i.sanitizer(e.target,"img","src")})},[r.link]:{match:Me(Ce),order:3,parse:(e,t,n)=>({children:Pe(t,e[1],n),target:je(e[2]),title:e[3]}),render:(e,t,n)=>d("a",{key:n.key,href:i.sanitizer(e.target,"a","href"),title:e.title},t(e.children,n))},[r.linkAngleBraceStyleDetector]:{match:Me(D),order:0,parse:e=>({children:[{text:e[1],type:r.text}],target:e[1],type:r.link})},[r.linkBareUrlDetector]:{match:Oe((e,t)=>t.inAnchor||i.disableAutoLink?null:Me(I)(e,t)),order:0,parse:e=>({children:[{text:e[1],type:r.text}],target:e[1],title:void 0,type:r.link})},[r.linkMailtoDetector]:{match:Me(U),order:0,parse(e){let t=e[1],n=e[1];return s.test(n)||(n="mailto:"+n),{children:[{text:t.replace("mailto:",""),type:r.text}],target:n,type:r.link}}},[r.orderedList]:ve(d,1),[r.unorderedList]:ve(d,2),[r.newlineCoalescer]:{match:Ie(x),order:3,parse:Ge,render:()=>"\n"},[r.paragraph]:{match:Oe(De),order:3,parse:Fe,render:(e,t,n)=>d("p",{key:n.key},t(e.children,n))},[r.ref]:{match:Me(H),order:0,parse:e=>(Q[e[1]]={target:e[2],title:e[4]},{}),render:We},[r.refImage]:{match:Re(P),order:0,parse:e=>({alt:e[1]||void 0,ref:e[2]}),render:(e,t,n)=>Q[e.ref]?d("img",{key:n.key,alt:e.alt,src:i.sanitizer(Q[e.ref].target,"img","src"),title:Q[e.ref].title}):null},[r.refLink]:{match:Me(_),order:0,parse:(e,t,n)=>({children:t(e[1],n),fallbackChildren:e[0],ref:e[2]}),render:(e,t,n)=>Q[e.ref]?d("a",{key:n.key,href:i.sanitizer(Q[e.ref].target,"a","href"),title:Q[e.ref].title},t(e.children,n)):d("span",{key:n.key},e.fallbackChildren)},[r.table]:{match:Ie(j),order:1,parse:Te,render(e,t,n){const r=e;return d("table",{key:n.key},d("thead",null,d("tr",null,r.header.map(function(e,i){return d("th",{key:i,style:Be(r,i)},t(e,n))}))),d("tbody",null,r.cells.map(function(e,i){return d("tr",{key:i},e.map(function(e,i){return d("td",{key:i,style:Be(r,i)},t(e,n))}))})))}},[r.text]:{match:Ue(ne),order:4,parse:e=>({text:e[0].replace(T,(e,t)=>i.namedCodesToUnicode[t]?i.namedCodesToUnicode[t]:e)}),render:e=>e.text},[r.textBolded]:{match:Re(X),order:2,parse:(e,t,n)=>({children:t(e[2],n)}),render:(e,t,n)=>d("strong",{key:n.key},t(e.children,n))},[r.textEmphasized]:{match:Re(J),order:3,parse:(e,t,n)=>({children:t(e[2],n)}),render:(e,t,n)=>d("em",{key:n.key},t(e.children,n))},[r.textEscaped]:{match:Re(ee),order:1,parse:e=>({text:e[1],type:r.text})},[r.textMarked]:{match:Re(K),order:3,parse:Fe,render:(e,t,n)=>d("mark",{key:n.key},t(e.children,n))},[r.textStrikethroughed]:{match:Re(Y),order:3,parse:Fe,render:(e,t,n)=>d("del",{key:n.key},t(e.children,n))}};!0===i.disableParsingRawHTML&&(delete V[r.htmlBlock],delete V[r.htmlSelfClosing]);const le=function(e){let t=Object.keys(e);function n(r,i){let l,a,o=[],c="",s="";for(i.prevCapture=i.prevCapture||"";r;){let d=0;for(;d<t.length;){if(c=t[d],l=e[c],i.inline&&!l.match.inline){d++;continue}const u=l.match(r,i);if(u){s=u[0],i.prevCapture+=s,r=r.substring(s.length),a=l.parse(u,n,i),null==a.type&&(a.type=c),o.push(a);break}d++}}return i.prevCapture="",o}return t.sort(function(t,n){let r=e[t].order,i=e[n].order;return r!==i?r-i:t<n?-1:1}),function(e,t){return n(function(e){return e.replace(b,"\n").replace($,"").replace(G,"    ")}(e),t)}}(V),ae=(oe=function(e,t){return function(n,r,i){const l=e[n.type].render;return t?t(()=>l(n,r,i),n,r,i):l(n,r,i)}}(V,i.renderRule),function e(t,n={}){if(Array.isArray(t)){const r=n.key,i=[];let l=!1;for(let r=0;r<t.length;r++){n.key=r;const a=e(t[r],n),o="string"==typeof a;o&&l?i[i.length-1]+=a:null!==a&&i.push(a),l=o}return n.key=r,i}return oe(t,e,n)});var oe;const ce=W(n);return q.length?d("div",null,ce,d("footer",{key:"footer"},q.map(function(e){return d("div",{id:i.slugify(e.identifier,ze),key:e.identifier},e.identifier,ae(le(e.footnote,{inline:!0})))}))):ce}/* harmony default export */ __webpack_exports__["ZP"] = (t=>{let{children:r="",options:i}=t,l=function(e,t){if(null==e)return{};var n,r,i={},l=Object.keys(e);for(r=0;r<l.length;r++)t.indexOf(n=l[r])>=0||(i[n]=e[n]);return i}(t,n);return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(Qe(r,i),l)});
//# sourceMappingURL=index.modern.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8687,519,8674,8101,774,3431,3954,9774,2888,179], function() { return __webpack_exec__(94913); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);